import { useControllableState } from '@radix-ui/react-use-controllable-state'
import { useId, useMemo } from 'react'

import { TabsContext } from './context'
import { Count } from './Count'
import { List } from './List'
import { Panel } from './Panel'
import { Tab } from './Tab'

interface TabsProps extends React.HTMLAttributes<HTMLDivElement> {
  activationMode?: 'manual' | 'automatic';
  children: React.ReactNode;
  defaultTab?: string;
  onTabChange?: (tab: string) => void;
  tab?: string;
  tabAlignment?: 'border-box' | 'content-box';
}

export function Tabs ({
  activationMode = 'automatic',
  children,
  defaultTab = '',
  onTabChange,
  tab,
  tabAlignment = 'border-box',
}: TabsProps) {
  const [activeTab, setActiveTab] = useControllableState({
    prop: tab,
    defaultProp: defaultTab,
    onChange: onTabChange,
  })
  const rootId = useId()

  const value = useMemo(
    () => ({ activationMode, activeTab, rootId, setActiveTab, tabAlignment }),
    [activeTab, activationMode, rootId, tabAlignment]
  )

  return (
    <TabsContext.Provider value={value}>
      {children}
    </TabsContext.Provider>
  )
}

Tabs.Count = Count
Tabs.List = List
Tabs.Panel = Panel
Tabs.Tab = Tab
